/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-07-09 17:58:22 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-08-22 21:18:34
 */



import * as formAuthState from '../store/auth/auth.state';
import * as formAuthReducer from '../store/auth/auth.reducer';
import { AuthEffects } from '../store/auth/auth.effect';


export interface AppState {
  auth: formAuthState.AuthState;
}

export const reducers = {
  auth: formAuthReducer.authReducer,
};

export const effects = [
  AuthEffects
];





// WEBPACK FOOTER //
// ./src/app/app.reducer.ts